import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HttpLoadingService {
  private readonly activeCount = signal(0);
  private showDelayTimer: ReturnType<typeof setTimeout> | null = null;

  readonly visible = signal(false);

  begin(): void {
    this.activeCount.update((count) => count + 1);
    if (this.activeCount() !== 1) {
      return;
    }

    this.showDelayTimer = setTimeout(() => {
      this.showDelayTimer = null;
      if (this.activeCount() > 0) {
        this.visible.set(true);
      }
    }, 200);
  }

  end(): void {
    this.activeCount.update((count) => Math.max(0, count - 1));
    if (this.activeCount() > 0) {
      return;
    }

    if (this.showDelayTimer) {
      clearTimeout(this.showDelayTimer);
      this.showDelayTimer = null;
    }

    this.visible.set(false);
  }
}
